import produce from "immer";
import {
    VIDEODESCRIPTIONS_SET,
    VIDEODESCRIPTIONS_SET_LOADING,
    VIDEODESCRIPTIONS_SET_SINGLE,
    VIDEODESCRIPTIONS_UPDATE,
    VIDEODESCRIPTIONS_REMOVE
} from "../types";

const initialState = {
    videoDescriptions: [],
    videoDescription: null,
    loading: false,
};

const videoDescriptionReducer = produce((draft, action) => {
    switch (action.type) {
        case VIDEODESCRIPTIONS_SET:
            draft.videoDescriptions = action.videoDescriptions;
            draft.loading = false;
            break;

        case VIDEODESCRIPTIONS_SET_SINGLE:
            draft.videoDescription = action.videoDescription;
            draft.loading = false;
            break;

        case VIDEODESCRIPTIONS_SET_LOADING:
            draft.loading = action.loading;
            break;

        case VIDEODESCRIPTIONS_UPDATE:
            draft.videoDescription = action.updatedVideoDescription;
            const index = draft.videoDescriptions.findIndex(
                v => v.id === action.updatedVideoDescription.id
            );
            if (index !== -1) {
                draft.videoDescriptions[index] = action.updatedVideoDescription;
            } else {
                draft.videoDescriptions.unshift(action.updatedVideoDescription);
            }
            break;

        case VIDEODESCRIPTIONS_REMOVE:
            draft.videoDescriptions = draft.videoDescriptions.filter(
                v => v.id !== action.videoDescriptionId
            );
            if (draft.videoDescription?.id === action.videoDescriptionId) {
                draft.videoDescription = null;
            }
            break;

        default:
            break;
    }
}, initialState);

export default videoDescriptionReducer;
